import {Component, inject} from '@angular/core';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {TranslateModule} from '@ngx-translate/core';
import {ReportBugPopupComponent} from './report-bug-popup/report-bug-popup.component';
import {ReportBugAttentionService} from './report-bug-attention.service';

@Component({
  selector: 'app-report-bug',
  standalone: true,
  imports: [TooltipModule, TranslateModule, ReportBugPopupComponent],
  templateUrl: './report-bug.component.html',
  styleUrls: ['./report-bug.component.scss'],
})
export class ReportBugComponent {
  popupRequested = false;
  reportStartRequestId = 0;

  // Pulses the icon when a page flags the bug report as especially relevant (e.g. a balance
  // update error on the connections page).
  readonly highlighted = inject(ReportBugAttentionService).highlighted;

  onBugClick(): void {
    this.popupRequested = true;
    this.reportStartRequestId++;
  }
}
